import React, { useState, useContext } from "react";
import { useMutation, useApolloClient } from "react-apollo";
import {
  ALL_COMPANY_POSTING_PERIODS_QUERY,
  CREATE_NEW_POSTING_PERIOD_YEAR
} from "../../../graphql/CompanyPostingPeriods/CompanyPostingPeriods.graphql";
import DataTable from "../../../components/DataTable";
import { COMPANY_POSTING_PERIOD_COLUMNS } from "./columns";
import { OpenPeriodModal } from "./components";
import {
  getFilterState,
  ourToast as toast,
  saveFilterState
} from "../../../utils";
import { ModalContext } from "../../../components/ModalProvider";
import { Confirmation } from "../../../components/modals";
import Loading from "../../../components/Loading";
import PageHeader from "../../../components/PageHeader";
import CompanyPostingPeriodsPageFilters from "./CompanyPostingPeriodsPageFilters";

const CompanyPostingPeriodsPage = () => {
  const client = useApolloClient();
  const today = new Date();
  const INITIAL_FILTER_STATE = getFilterState(
    "COMPANY_POSTING_PERIOD_FILTERS",
    {
      PeriodEndDateTime_gte: new Date(`01/01/${today.getFullYear()}`).setHours(
        0,
        0,
        0,
        0
      ),
      PeriodEndDateTime_lte: new Date(`12/31/${today.getFullYear()}`).setHours(
        23,
        59,
        59,
        999
      )
    }
  );
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const { setModalOpen } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const [createPostingPeriod] = useMutation(CREATE_NEW_POSTING_PERIOD_YEAR, {
    refetchQueries: ["ALL_COMPANY_POSTING_PERIODS_QUERY"]
  });
  const handleSetFilters = inputs => {
    saveFilterState("COMPANY_POSTING_PERIOD_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ ...INITIAL_FILTER_STATE });

  const addNewYear = async () => {
    const { data } = await client.query({
      query: ALL_COMPANY_POSTING_PERIODS_QUERY,
      fetchPolicy: "network-only"
    });
    // Sorting the data by PeriodEndDateTime DESC
    const sorted = data.CompanyPostingPeriods.sort(
      (a, b) => new Date(b.PeriodEndDateTime) - new Date(a.PeriodEndDateTime)
    );
    const mostRecentDate = sorted[0]?.PeriodEndDateTime
      ? new Date(sorted[0]?.PeriodEndDateTime)
      : new Date();
    const performCreateNewYer = async () => {
      setLoading(true);
      setModalOpen(false);
      await createPostingPeriod({
        variables: {
          Year: mostRecentDate.getFullYear() + 1
        }
      });
      setLoading(false);
      toast.success("Posting Periods created successfully.");
    };
    setModalOpen(
      true,
      <Confirmation
        message={`Are you sure you would like to add posting periods for ${mostRecentDate.getFullYear() +
          1}?`}
        onConfirm={performCreateNewYer}
      />
    );
  };

  const handleRowClick = async companyPostingPeriod => {
    if (!companyPostingPeriod.Open) {
      setModalOpen(
        true,
        <OpenPeriodModal
          companyPostingPeriod={companyPostingPeriod}
          onComplete={() => {
            setModalOpen(false, "");
          }}
        />
      );
    }
  };

  if (loading) return <Loading />;

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={CompanyPostingPeriodsPageFilters}
        columns={COMPANY_POSTING_PERIOD_COLUMNS}
        filters={filters}
        name="CompanyPostingPeriod"
        query={ALL_COMPANY_POSTING_PERIODS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Posting Periods"
        onAddClick={addNewYear}
      />
      <DataTable
        columns={COMPANY_POSTING_PERIOD_COLUMNS}
        dataQuery={ALL_COMPANY_POSTING_PERIODS_QUERY}
        initialSortBy={[
          { id: "PeriodEndDateTime", desc: true },
          { id: "Module", desc: false }
        ]}
        name="CompanyPostingPeriod"
        where={filters}
        onRowClick={handleRowClick}
      />
    </React.Fragment>
  );
};
CompanyPostingPeriodsPage.propTypes = {};
export default CompanyPostingPeriodsPage;
